/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc
 */

export let ComHubspotBuyingModelsRpcDtb;
(function (_ComHubspotBuyingModelsRpcDtb) {})(ComHubspotBuyingModelsRpcDtb || (ComHubspotBuyingModelsRpcDtb = {}));
export let ComHubspotBuyingModelsRpcDtbChirp;
(function (_ComHubspotBuyingModelsRpcDtbChirp) {})(ComHubspotBuyingModelsRpcDtbChirp || (ComHubspotBuyingModelsRpcDtbChirp = {}));
export let ComHubspotBuyingModelsRpcDtbChirpV2;
(function (_ComHubspotBuyingModelsRpcDtbChirpV) {})(ComHubspotBuyingModelsRpcDtbChirpV2 || (ComHubspotBuyingModelsRpcDtbChirpV2 = {}));
/**
 *  Request model for purchasing parent products.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
/**
 *  Request model for purchasing quantity packs.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
export const createDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'zQRL67kZOeeA1hXn2coGG5hL_Uso95rB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicDirectToBuyRpc',
  rpcName: 'getDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'RwkVwEpJCiaeLOO8zYK23ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getDirectToBuyConfigV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicDirectToBuyRpc',
  rpcName: 'getDirectToBuyConfigV2',
  auth: 'external',
  fingerprint: 'RwkVwEpJCiZJYnad7bV2eJhL_Uso95rB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};